"use client";
import { useEffect as e, useId as t, useRef as n, useState as r } from "react";
//#region src/components/fields/useTextField.ts
function i(i) {
	let a = t(), o = i.id ?? a, s = `${o}-support`, [c, l] = r(i.defaultValue ?? ""), [u, d] = r(!1), f = n(null), p = i.value ?? c, m = (e) => {
		i.value === void 0 && l(e), i.onValueChange?.(e);
	};
	e(() => {
		let e = f.current?.form, t = (e) => {
			queueMicrotask(() => {
				e.defaultPrevented || (i.value === void 0 && l(i.defaultValue ?? ""), d(!1));
			});
		};
		return e?.addEventListener("reset", t), () => e?.removeEventListener("reset", t);
	});
	let h = i.errorConfig && (u || i.errorConfig.reveal === "immediate") ? i.errorConfig.message : void 0, g = h || i.description || i.disableConfig?.isDisabled && i.disableConfig.reason;
	return {
		id: o,
		supportId: s,
		value: p,
		change: m,
		error: h,
		describedBy: [i["aria-describedby"], g ? s : void 0].filter(Boolean).join(" ") || void 0,
		controlRef: f,
		blur: () => {
			d(!0);
		}
	};
}
//#endregion
export { i as useTextField };
